export default __webpack_public_path__ + "assets/logos/097d6b72475f6a66705483a5c1129b31.png";